module.exports = __webpack_public_path__ + "static/media/ue5_2.d735ea96.jpg";